import { render, staticRenderFns } from "./DetalleTarea.vue?vue&type=template&id=4d118af4"
import script from "./DetalleTarea.vue?vue&type=script&lang=js"
export * from "./DetalleTarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports